module.exports = __webpack_public_path__ + "static/media/heart-square.7efe406c.svg";